import { ReplaceUserOnClientFormValues } from "../types";
import { useState } from "react";
import { useRequest } from "../../../hooks/useRequest";
import useHttpResponseAlert from "../../../hooks/useHttpResponseAlert";
import routes from "../../../routes";

function useReplaceMainUserForClient(id: string) {
  const [isReplacing, setReplacing] = useState<boolean>(false);

  const { fetch, response, error, loading } = useRequest();

  const { alert, setAlert } = useHttpResponseAlert(
    error,
    response,
    "Main user has been successfully replaced!",
  );

  const handleSubmit = async (form: ReplaceUserOnClientFormValues) => {
    const payload = {
      mainUser: {
        firstName: form["main-user-first-name"],
        lastName: form["main-user-last-name"],
        email: form["email"],
      },
    };
    const result = await fetch(
      "PATCH",
      routes.api.client.individual({ id }),
      payload,
    );
    if (result && result.status === 200) {
      setReplacing(false);
    }
  };

  return {
    isReplacing,
    setReplacing,
    replace: handleSubmit,
    mainUser: response?.data.mainUser,
    loading,
    alert,
    setAlert,
  };
}

export default useReplaceMainUserForClient;
